import React, { useContext } from "react";
import { Checkbox } from "../../view/Checkbox";
import { deepCopy } from "../../utils";
import { TableContext, PopupContext } from "../../index";
import dots from "../../_resources/img/vdots.png";
import { POPUP_TYPES } from "../../view/popup/PopupContainer";
import {getScanOutputbyId} from "./vulscanService";
//import pdfIcon from "../_resources/img/pdf.svg";
//import { downloadReport } from "./reportService";


function VulscanTableRow({ data, index }) {

    const { config, setConfig } = useContext(TableContext);
    const { setPopup } = useContext(PopupContext);

    const onCheckboxChange = () => {
        let selectedRows = deepCopy(config.selected);
        if (selectedRows.includes(data.id)) {
            selectedRows.splice(selectedRows.indexOf(data.id), 1);
        } else {
            selectedRows.push(data.id)
        }
        setConfig({ ...config, selected: selectedRows })
    }

     //This function is used to convert bigint date to datetimeformat
     const getDateTimeFormat = (bigIntTime) => {
        if (!bigIntTime) {
            return ''
        }
        let datetime = Number(bigIntTime)
        let datetimeformat = 'N/A';
        const dateObject = new Date(datetime)
        datetimeformat = dateObject.toLocaleString()
        return datetimeformat;
    }

    //const onDownloadClick = () => downloadReport(data);

    const onViewScanOutput = async () => setPopup(
        {
            type: POPUP_TYPES.VIEW_NMAP_SCAN_OUTPUT,
            output: await getScanOutputbyId(data.id)
            //output: data.output,
            // confirm: confirmEventCreation,
        },
    );

    return (
        <tr key={index}>
            <td>
                <Checkbox checked={config.selected.includes(data.id)} onClick={() => onCheckboxChange()} />
            </td>
            <td>
                {data.target}
            </td>
            <td>
                {data.type}
            </td>
            <td>
                {data.status}
            </td>
            <td>
                {data.scheduled}
            </td>
            <td>
                {getDateTimeFormat(data.lastRun)}
            </td>            
            <td>
                <div className="btn oct_btn-tool-table" onClick={() => onViewScanOutput()}>
                    <i className="fas fa-ellipsis-v"></i>
                    <img src={dots} alt="Icon" className="oct_vertical_align" />
                </div>
            </td>
        </tr>
    )


}

export default VulscanTableRow;
